import React from 'react'
import {connect} from 'react-redux'

import {
  VIEWPORT_TYPES
} from './config/constants'

const {PHONE} = VIEWPORT_TYPES

import CRUDList from './crud_list'
import GroupChatAvatar from './group_chat_avatar'
import GroupChatBookmarkButton from './group_chat_bookmark_button'
import GroupChatSubscribeButton from './group_chat_subscribe_button'

class GroupChatsBookmarked extends React.Component {
  constructor (props) {
    super(props)

    this.formatGroupChatName = this.formatGroupChatName.bind(this)
    this.renderCustomListAction = this.renderCustomListAction.bind(this)
  }

  formatGroupChatName (name, group) {
    return (
      <div>
        <div style={{display: 'inline-block', marginRight: 4, fontSize: 14}}>
          <GroupChatAvatar size={30} initials={group.get('initials')}/>
        </div>
        <h5 style={{display: 'inline-block', fontSize: 14}}>{name}</h5>
      </div>
    )
  }

  getAttrs () {
    return [
      {name: 'name', label: 'Group Chat', isSortable: true, isPrimary: true, formatter: this.formatGroupChatName}
    ]
  }


  renderCustomListAction (group) {
    const width = this.props.viewportType === PHONE ? 'auto' : 250

    return (
      <div className='group-chat-resource-actions' style={{width, textAlign: 'right'}}>
        <GroupChatBookmarkButton groupId={group.get('key')} style={{marginRight: 5}}/>
        <GroupChatSubscribeButton groupId={group.get('key')}/>
      </div>
    )
  }

  render () {
    if (this.props.groupChats && this.props.groupChats.size === 0) {
      return (
        <div style={{textAlign: 'center', margin: '10px auto'}}>
          You don't have any bookmarked group chats.
        </div>
      )
    }
    else {
      return (
        <CRUDList
          resources={this.props.groupChats}
          attrs={this.getAttrs()}
          isActionsEnabled={true}
          isActionDetailsEnabled={false}
          customAction={this.renderCustomListAction}
          limit={10}/>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    groupChats: state.getIn(['groups', '_bookmarks', 'list']),
    viewportType: state.getIn(['viewport', 'type'])
  }
}

const GroupChatsBookmarkedContainer = connect(
  mapStateToProps
)(GroupChatsBookmarked)

export default GroupChatsBookmarkedContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chats_bookmarked.js
 **/